import { Lock, Landmark, CreditCard, Briefcase, Ship } from "lucide-react";

export function StageGate({ stages, need, children, className = "", testid, label, compact }) {
  if (!stages) return <div className={`vcb-panel rounded-xl p-5 min-h-[160px] animate-pulse ${className}`} />;
  if ((stages.current_stage || 0) >= need) return children;
  const s = stages.stages[need - 1];
  return (
    <div data-testid={testid || `vcb-stage-gate-${need}`} className={`relative rounded-xl border border-[#D8B23E]/30 bg-[#070604] p-6 overflow-hidden ${className}`}>
      <div className="absolute inset-0 pointer-events-none opacity-[0.07]" style={{ backgroundImage: "repeating-linear-gradient(135deg,#D8B23E 0 1px,transparent 1px 14px)" }} />
      <div className="relative flex items-start gap-4">
        <div className="h-10 w-10 shrink-0 rounded-full border border-[#D8B23E]/50 grid place-items-center text-[#D8B23E]"><Lock size={15} /></div>
        <div className="min-w-0">
          <div className="font-grotesk text-[9px] uppercase tracking-[0.34em] text-[#D8B23E]">{label ? `${label} · ` : ""}Locked · Unlocks at Stage {s.numeral}</div>
          <div className="font-serif text-xl md:text-2xl text-[#D8B23E] mt-1">{s.title}</div>
          <p className="font-body text-[12px] text-[#A9A9A2] mt-2 leading-relaxed max-w-xl">This desk is released at the discretion of the Vinci desk once your account reaches Stage {s.numeral}. You will be notified by e-mail the moment it is unlocked.</p>
          {!compact && (
            <ul className="mt-3 grid sm:grid-cols-2 gap-x-6 gap-y-1">
              {s.features.map((f) => <li key={f} className="font-body text-[11px] text-[#A9A9A2] flex gap-2"><span className="text-[#D8B23E]">◆</span>{f}</li>)}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

const INSTRUMENTS = [
  { k: "Overdraft facility", v: "Draw beyond your float against approved limits.", icon: Landmark },
  { k: "Credit line", v: "Revolving credit mapped to your settlement history.", icon: CreditCard },
  { k: "Working capital", v: "Short-tenor instruments for procurement cycles.", icon: Briefcase },
  { k: "Trade finance", v: "LC-backed and invoice-backed trade tools.", icon: Ship },
];

export function CreditLiquidityPanel() {
  return (
    <div className="vcb-panel rounded-xl p-5" data-testid="vcb-credit-panel">
      <div className="flex items-center justify-between mb-4">
        <div className="cinzel text-xs text-neutral-300">Credit &amp; Liquidity</div>
        <span className="vcb-mono text-[10px] text-[#D8B23E] tracking-widest">◉ STAGE IV ACTIVE</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {INSTRUMENTS.map((i) => (
          <div key={i.k} className="border border-[#1E222A] bg-[#0A0B0E] rounded-lg p-4" data-testid={`vcb-credit-${i.k.toLowerCase().replace(/\s+/g, "-")}`}>
            <i.icon size={14} className="text-[#D8B23E]" />
            <div className="font-serif text-[14px] text-[#F5F5F0] mt-2">{i.k}</div>
            <p className="text-[11px] text-neutral-500 mt-1 leading-relaxed">{i.v}</p>
          </div>
        ))}
      </div>
      <a href="/account" data-testid="vcb-credit-apply" className="mt-4 inline-flex items-center gap-2 bg-[#D8B23E] text-black px-5 py-2.5 font-grotesk text-[9px] uppercase tracking-[0.28em] hover:bg-[#E5C450]">Apply for a credit line</a>
    </div>
  );
}
